import KeywordsBulkOperationsBtns from "@buttons/KeywordsBulkOperationsBtns";
import BulkActionsMenu from "@drop-downs/BulkActionsMenu";
import {
    resetPerformanceOverview,
    agBtnExport,
    getActiveModule,
    resetCurrentModule,
    titleCase,
    getClientId,
} from "@ts/utils";
import { useDispatch, useSelector } from "react-redux";
import {
    Actions,
    IGlobalGridApi,
    ITitle,
    ParentModule,
    SubModule,
} from "@ts/common-types";
import { useGetBulkActionsMenuData } from "@hooks/useGetBulkActionsMenuData";
import ExportGridBtn from "@/components/buttons/ExportGridBtn";
import { useGetModulesData, usePermissionCheck } from "@/hooks/AllCustomHooks";
import { Button } from "antd";
import { updateCampaignCreationDisplay } from "@/features/campaignCreationSlice";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { useMemo } from "react";

const SubHeader = () => {
    const title = useSelector((state: ITitle) => state.title.value);
    const globalGridApi = useSelector(
        (state: IGlobalGridApi) => state.globalGridApi.value
    );
    const { activeModule } = getActiveModule();
    const activeClientId: number = getClientId();
    
    const actions =
        useGetModulesData({
            type: "actions",
            activeModuleName: activeModule,
        }) || [];

    const createCampaignFeature =
        useFeatureIsOn("CAMPAIGN_WIZARD_FEATURE") || false;

    const { canCreateCampaign } = usePermissionCheck();

    const isCampaignCreationVisible = useMemo(() => {
        return (
           canCreateCampaign && createCampaignFeature &&
            actions.includes(Actions.BULK_CAMPAIGN_CREATION)
        );
    }, [createCampaignFeature, activeClientId, actions, canCreateCampaign]);


    const bulkActionData = useGetBulkActionsMenuData();
    const filteredBulkActionData =
        !canCreateCampaign && bulkActionData
            ? bulkActionData.filter(
                  (options) => options.operation !== "create-campaign"
              )
            : bulkActionData;
    const dispatch = useDispatch();

    return (
        <>
            <div className="sub-header p-2 d-sm-flex flex-row justify-content-between align-items-center">
                <div className="clearfix" id="savedFilters"></div>
                <div
                    className="text-center text-sm-start"
                    style={{ height: "100%" }}
                >
                    <div className="d-flex">
                        {activeModule !== SubModule.OVERVIEW &&
                            activeModule !== ParentModule.REVSTACK && (
                                <>
                                    {isCampaignCreationVisible && (
                                        <div>
                                            <Button
                                                type="primary"
                                                style={{
                                                    fontWeight: 400,
                                                    fontSize: 14
                                                  }}
                                                onClick={() => {
                                                    dispatch(updateCampaignCreationDisplay(true));
                                                }}
                                            >
                                                Create Campaigns
                                            </Button>
                                        </div>
                                    )}
                                    <Button
                                        type="link"
                                        className="text-primary anchor-class"
                                        id="performance-overview-reset-filters-btn"
                                        style={{
                                          fontWeight: 400,
                                          fontSize: 14
                                        }}
                                        onClick={() =>
                                            title ===
                                            titleCase(
                                                ParentModule.PERFORMANCE_OVERVIEW
                                            )
                                                ? resetPerformanceOverview(
                                                      globalGridApi
                                                  )
                                                : resetCurrentModule(
                                                      globalGridApi
                                                  )
                                        }
                                    >
                                        Reset Filters
                                    </Button>
                                </>
                            )}

                        {activeModule === SubModule.KEYWORD ? (
                            <KeywordsBulkOperationsBtns />
                        ) : filteredBulkActionData.length ? (
                                <BulkActionsMenu
                                    data={filteredBulkActionData}
                                />
                        ) : null}
                        <ExportGridBtn
                            onClickFunction={() => agBtnExport(globalGridApi)}
                            isSubModule={false}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default SubHeader;
